module.exports = __webpack_public_path__ + "img/heart_intelligence.77872d62.png";